import React, { useState, useEffect } from "react";
import { C, font, text } from "../theme";
import { PasswordInput } from "../components/ui";
import { evaluatePassword } from "../lib/passwordPolicy";
import { setFlash } from "../lib/flash";

export default function ChangePasswordPage({ onChanged }) {
  const [currentPassword, setCurrent] = useState("");
  const [newPassword, setNew] = useState("");
  const [err, setErr] = useState("");
  const canSubmit = currentPassword.length > 0 && evaluatePassword(newPassword).valid;

  useEffect(() => { document.title = "Set a new password — SGNIC P2P"; }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    const res = await fetch("/api/auth/change-password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ currentPassword, newPassword }),
    });
    if (!res.ok) { const b = await res.json().catch(() => ({})); setErr(b.error || "Could not change password"); return; }
    // Acknowledge the gate on the next screen (UX-81) — the view swaps immediately.
    setFlash("Password updated.");
    onChanged();
  };

  return (
    <div style={{ fontFamily: font, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: C.gray50 }}>
      <form onSubmit={submit} style={{ background: C.white, padding: 32, borderRadius: 10, border: `1px solid ${C.gray200}`, width: 360, display: "flex", flexDirection: "column", gap: 12 }}>
        <h1 style={{ margin: 0, fontSize: text.h1, color: C.gray1100 }}>Set a new password</h1>
        <div style={{ color: C.gray500, fontSize: text.sm }}>You must change your temporary password before continuing.</div>
        {err && <div role="alert" style={{ color: C.danger, fontSize: text.md }}>{err}</div>}
        <PasswordInput aria-label="Current password" placeholder="Current password" value={currentPassword} onChange={e => setCurrent(e.target.value)} required />
        <PasswordInput aria-label="New password" placeholder="New password" value={newPassword} onChange={e => setNew(e.target.value)} required showStrength />
        <button type="submit" disabled={!canSubmit} style={{ padding: "10px 12px", background: canSubmit ? C.gray1100 : C.gray300, color: C.white, border: "none", borderRadius: 6, cursor: canSubmit ? "pointer" : "not-allowed" }}>Update password</button>
      </form>
    </div>
  );
}
